export const baseUrl = 'https://raw.githubusercontent.com/Hossik/confusion/gh-pages';
